import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Person } from '@material-ui/icons';
import React from 'react';
import { useAuth0 } from '../Auth0Provider';

const useStyles = makeStyles(theme => ({
  username: { marginLeft: theme.spacing(1), flexGrow: 1 }
}));

const UserInfo = function UserInfo(): React.ReactElement | null {
  const { user } = useAuth0();
  const classes = useStyles();

  if (!user) {
    return null;
  }

  // Try userName from API first, then fallback to Auth0 given_name + family_name
  const userDisplayName =
    user.userName ||
    (user.given_name && user.family_name
      ? `${user.given_name} ${user.family_name}`
      : 'User');

  return (
    <>
      <Person />
      <Typography className={classes.username}>{userDisplayName}</Typography>
    </>
  );
};

export default UserInfo;
